﻿import React, { useRef } from "react";

export interface IMessagePopupProps {
    message?: string;
    timeout?: number;
    image?: string;
    iteration: number;
    buttonText?: string;
    buttonAction?: (param: string) => void;
    buttonParam?: string;
}

export const ViewShareMessagePopup: React.FunctionComponent<
    IMessagePopupProps
> = (props): React.ReactElement => {
    const popupRef = useRef<HTMLDivElement>();

    const onTimeout = (): void => {
        popupRef.current.className = `viewsharepopup hide`;
    };

    const onButtonClick = (): void => {
        popupRef.current.className = `ViewSharepopup hide`;
        void props.buttonAction(props.buttonParam);
    };

    const popup = (): React.ReactElement => {
        let timer: number;

        // Clear any already existing timer.
        if (timer != null) {
            clearTimeout(timer);
        }

        // Set a new timer to hide the message.
        if (props.timeout && props.message) {
            timer = setTimeout(onTimeout, props.timeout);
        }
        // Render the message.
        if (props.message) {
            // Provide the iteration, this forces react to set the class back to being visible.
            const classname = `ViewSharepopup-position ${props.iteration}`;

            return (
                <div className={`ViewSharepopup`}>
                    <div className={classname}>
                        <div
                            className={`viewsharepopup-container`}
                            ref={popupRef}
                        >
                            {props.image !== null && (
                                <div className={`viewshare-image`}>
                                    <img
                                        alt={props.buttonText}
                                        src={props.image}
                                    />
                                </div>
                            )}
                            <p>{props.message}</p>
                            {props.buttonText !== null && (
                                <button onClick={onButtonClick}>
                                    {props.buttonText}
                                </button>
                            )}
                        </div>
                    </div>
                </div>
            );
        } else {
            return null;
        }
    };

    return popup();
};
